module.exports = __webpack_public_path__ + "static/media/sample-showcase-page.2f2dc672.png";